/**
 * @generated SignedSource<<6af66830891cbaa3c77f40d15cfc4822>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OverviewAbout_tradeFirm$data = {
  readonly name: string | null;
  readonly publicProfile: {
    readonly about: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "OverviewAbout_tradeFirm";
};
export type OverviewAbout_tradeFirm$key = {
  readonly " $data"?: OverviewAbout_tradeFirm$data;
  readonly " $fragmentSpreads": FragmentRefs<"OverviewAbout_tradeFirm">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OverviewAbout_tradeFirm",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "about",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradeFirmType",
  "abstractKey": null
};

(node as any).hash = "36f67623e2f9869edb2e5eaa9cd0a46a";

export default node;
